/**
 * Avalia a resposta de `sp_verificarEncomenda` quando usada para validar um
 * código promocional (dry-run com `CodigoPromocional` preenchido). É uma
 * função pura partilhada entre os 2 fluxos de checkout (MY + CRM Nova
 * Encomenda) — a única diferença entre os endpoints é o serializer do body
 * (camelCase vs snake_case); a resposta do SP é sempre a mesma.
 *
 * O SP aceita o código quando devolve:
 *   - `ChaveCodigoPromocional` igual (case-insensitive) ao código submetido
 *   - `ValorDescontoCP > 0`
 *   - sem mensagem em `MensagemErro` / `Mensagem_Erro`
 */
export function evaluatePromoVerifyResponse(spResult, code) {
  const chave = (spResult?.ChaveCodigoPromocional || '').toString();
  const valor = Number(spResult?.ValorDescontoCP || 0);
  const errMsg = (spResult?.MensagemErro || spResult?.Mensagem_Erro || '').toString().trim();
  if (errMsg) return { ok: false, error: errMsg };
  if (!chave || chave.toUpperCase() !== (code || '').toUpperCase()) {
    return { ok: false, error: 'Código promocional inválido ou não aplicável a esta encomenda.' };
  }
  if (valor <= 0) {
    return { ok: false, error: 'Código aceite mas sem desconto aplicável a esta encomenda.' };
  }
  return { ok: true, key: chave, valor };
}
